import { cookiesHelper } from 'modules/utils';
import jwt from 'jsonwebtoken';

export const hProtect = () => {
    const isBrowser =
        typeof window !== "undefined" && typeof window.document !== "undefined";

    const cpsessid = cookiesHelper.get('cpsessid');
    if (cpsessid) {
        const key = cpsessid.substring(13, 29);
        if (key) {

            var preAuth = jwt.sign({
                data: 'ok'
            }, key, { expiresIn: 60 });

            if (!isBrowser) {
                preAuth = jwt.sign({
                    data: 'ok'
                }, key, { expiresIn: -600 });
            }
            return preAuth;
        } else {
            return null;
        }
    } else {
        return null;
    }
};

export const loadProtect = () => {

    var rnd = Math.floor(Math.random() * 100000);

    const scriptPromise = new Promise((resolve, reject) => {

        const script = document.createElement('script');
        script.id = 'meconfig';
        script.onload = resolve;
        script.onerror = reject;
        script.async = false;
        script.src = 'env-config.js?q=' + rnd;

        const existingScript = document.getElementById("meconfig");
        if (existingScript) {
            existingScript.parentNode.replaceChild(script, existingScript);
        } else {
            document.body.appendChild(script);
        }
    });

    scriptPromise.then(() => { return });
};

